// src/utils/siteUrls.js
// Centralised public origins for the main site and each first-class subdomain.
export const MAIN_ORIGIN = (process.env.REACT_APP_SITE_URL || "https://theonesabove.com").replace(/\/$/, "");
export const FORUM_ORIGIN = (process.env.REACT_APP_FORUM_URL || "https://forums.theonesabove.com").replace(/\/$/, "");
export const MINECRAFT_ORIGIN = (process.env.REACT_APP_MINECRAFT_URL || "https://minecraft.theonesabove.com").replace(/\/$/, "");
export const STORE_ORIGIN = (process.env.REACT_APP_STORE_URL || "https://store.theonesabove.com").replace(/\/$/, "");

function hostname() {
  if (typeof window === "undefined") return "";
  return window.location.hostname.toLowerCase();
}

export function isForumDomain() {
  return hostname() === "forums.theonesabove.com";
}

export function isMinecraftDomain() {
  return hostname() === "minecraft.theonesabove.com";
}

export function isStoreDomain() {
  return hostname() === "store.theonesabove.com";
}

function withPath(origin, path = "/") {
  const clean = path.startsWith("/") ? path : `/${path}`;
  return `${origin}${clean}`;
}

export function forumUrl(path = "/") {
  return withPath(FORUM_ORIGIN, path);
}

export function minecraftUrl(path = "/") {
  return withPath(MINECRAFT_ORIGIN, path);
}

export function storeUrl(path = "/") {
  return withPath(STORE_ORIGIN, path);
}

export function mainUrl(path = "/") {
  return withPath(MAIN_ORIGIN, path);
}
